export const dualPaneSelectInventoryCheck = 'Select an inventory';
export const dualPaneMultiSelectPrefix = 'Selected: ';
